<template>
	
	<div class="page-wrap" :class="category.customStyle">
		<subCategoryHeading :category="category"></subCategoryHeading>
		<subCategoryLinks v-if="category.activities.length > 0" :activities="category.activities"></subCategoryLinks>
		<div class="subcategoryimage" v-else>
			<img class="subcategoryimage" :src="category.bigImage" :alt="category.subTitle"/>
			<ul class="subcategory__glance" v-if="category.atAGlance">
				<li class="subcategory__glance-title"><h5>At a glance:</h5></li>
				<li v-for="point in category.atAGlance">{{point}}</li>
			</ul>
		</div>
		<div class="anim-leave"></div>
	</div>
	
</template>

<script>
	import { CATEGORIES } from '@/js/categories.js';
	import subCategoryHeading from '@/components/SubCategoryHeading.vue';
	import subCategoryLinks from '@/components/SubCategoryLinks.vue';

	export default {
		name: 'subCategory',
		components: {
			subCategoryHeading,
			subCategoryLinks
		},

        beforeRouteUpdate(to, from, next) {
            this.category = this.categories[to.params.id]
            next()
        },

		data: function() {
			return {
				category: null,
				categories: CATEGORIES
			}
		},

      created () {
      let parentCat = this.categories.find( cat => { return cat.urlSegment === this.$router.currentRoute.params.urlSegment }) 
         this.category = parentCat.subCategories.find( subCat => {
            return subCat.subUrlSegment === this.$router.currentRoute.params.subUrlSegment
         })
      }

	}
</script>
